__turbopack_context__.v({
  "active": "styles-module-scss-module__oARH2a__active",
  "activeCitrus": "styles-module-scss-module__oARH2a__activeCitrus",
  "carouselContainer": "styles-module-scss-module__oARH2a__carouselContainer",
  "centerAlign": "styles-module-scss-module__oARH2a__centerAlign",
  "dot": "styles-module-scss-module__oARH2a__dot",
  "dotNavPlaceholder": "styles-module-scss-module__oARH2a__dotNavPlaceholder",
  "leftAlign": "styles-module-scss-module__oARH2a__leftAlign",
  "mediaContainer": "styles-module-scss-module__oARH2a__mediaContainer",
  "mobileDotNav": "styles-module-scss-module__oARH2a__mobileDotNav",
  "mobileDotNavContainer": "styles-module-scss-module__oARH2a__mobileDotNavContainer",
  "mobileFullBleed": "styles-module-scss-module__oARH2a__mobileFullBleed",
  "roundedCorners": "styles-module-scss-module__oARH2a__roundedCorners",
  "wideSpacing": "styles-module-scss-module__oARH2a__wideSpacing",
});
